export default __webpack_public_path__ + "static/media/scale.768005b3.png";